(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-validate/assets/javascript/pages/validated/page.js') >= 0) return;  svs.modules.push('/modules/tickets-validate/assets/javascript/pages/validated/page.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useState = _React.useState,
  useEffect = _React.useEffect,
  Fragment = _React.Fragment;
const Button = svs.ui.ReactButton;
const PageWrapper = svs.ticketsValidate.components.PageWrapper;
const Envelope = svs.tur.Envelope;
const BubbleWinMessage = svs.tur.bubbleWinMessage.components.BubbleWinMessage;
const templateBranding = svs.tickets.data.templateConfig.branding;
const GamingAccountInfo = svs.ticketsValidate.components.GamingAccountInfo;
const WIN_ONE_TICKET = svs.bubble_win_message.extraIcon.WIN_ONE_TICKET;
const _svs$ticketgames$tick = svs.ticketgames.ticketUtility,
  payVouchers = _svs$ticketgames$tick.payVouchers,
  getVoucherExpirationDate = _svs$ticketgames$tick.getVoucherExpirationDate;
const _svs$ticketgames$tick2 = svs.ticketgames.ticketUtility.utils,
  executeSpecialWinAction = _svs$ticketgames$tick2.executeSpecialWinAction,
  logger = _svs$ticketgames$tick2.logger,
  tracking = _svs$ticketgames$tick2.tracking,
  showWonTicketRedeemedDialog = _svs$ticketgames$tick2.showWonTicketRedeemedDialog,
  showWonTicketUnredeemableDialog = _svs$ticketgames$tick2.showWonTicketUnredeemableDialog,
  showErrorDialog = _svs$ticketgames$tick2.showErrorDialog;
const WonTicketWinActions = _ref => {
  let ticketId = _ref.ticketId,
    paused = _ref.paused;
  const wonTicketState = svs.ticketsValidate.utils.getWonTicketState(ticketId);
  useEffect(() => {
    if (!wonTicketState) {
      showWonTicketUnredeemableDialog({
        onClose: () => {
          svs.utils.url.navigate(svs.core.urlMapping.get('myBetsHome'));
        }
      });
    }
  }, []);
  const redeemWonTicketDigital = () => {
    executeSpecialWinAction({
      extraicon: WIN_ONE_TICKET
    }, _ref2 => {
      let action = _ref2.action,
        wonTicket = _ref2.wonTicket,
        error = _ref2.error;
      if (wonTicket) {
        svs.ticketsValidate.utils.setRedeemedWonTicket(ticketId, {
          redeemType: 'digital',
          data: {
            wagerId: wonTicket.wagerId
          }
        });
        showWonTicketRedeemedDialog({
          onScratchNow: () => {
            svs.utils.url.navigate(svs.core.urlMapping.get('triss_BetDetail').replace(':wagerId', wonTicket.wagerId));
          },
          onScratchLater: () => {
            svs.utils.url.navigate(svs.core.urlMapping.get('myBetsHome'));
          }
        });
      }
      if (error) {
        logger.error("Error executing special win action ".concat(action, ": ").concat(error));
        if (action === WIN_ONE_TICKET) {
          showErrorDialog({
            title: 'Något gick fel när din Triss skulle hämtas.',
            message: 'Vi har därför satt in 30 kr på ditt Spelkonto vilket motsvarar värdet på lotten.'
          });
        }
      }
    });
  };
  const redeemWonTicketPhysical = () => {
    const ticketInfo = svs.ticketgames.gameHandler.getPackageGame();
    payVouchers({
      voucher: {
        count: 1,
        productId: ticketInfo.voucherId || 3,
        skinId: ticketInfo.themeName,
        skinPosition: 1,
        value: ticketInfo.price,
        name: ticketInfo.name,
        type: ticketInfo.type,
        price: ticketInfo.price,
        branding: ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.branding
      },
      shouldConfirmPayment: false,
      onCancel: () => {},
      onDone: async _ref3 => {
        let vouchers = _ref3.vouchers,
          failure = _ref3.failure;
        if (vouchers.length && !failure) {
          const multiBuyId = vouchers[0].MultiBuyId ? vouchers[0].MultiBuyId : vouchers[0].VoucherId.substring(0, 8);
          const voucherId = vouchers[0].VoucherId;
          const ticketType = ticketInfo.type;
          const value = ticketInfo.price;
          const expirationDate = await getVoucherExpirationDate(voucherId);
          svs.ticketsValidate.utils.setRedeemedWonTicket(ticketId, {
            redeemType: 'physical',
            data: {
              ticketType,
              multiBuyId,
              voucherId,
              value,
              expirationDate
            }
          });
          svs.ticketsValidate.utils.navigateToVoucher({
            ticketType,
            multiBuyId,
            voucherId,
            value,
            expirationDate
          });
        }
      }
    });
  };
  return React.createElement("div", {
    className: "u-flex u-flex-column u-flex-justify-content-center padding-bottom-1"
  }, React.createElement("div", {
    className: "u-flex u-flex-column"
  }, !paused && (!wonTicketState || wonTicketState.canRedeem) && React.createElement(Fragment, null, React.createElement("p", null, "Du kan skrapa din nya Triss digitalt, nu p\xE5 en g\xE5ng. Om du hellre h\xE4mtar ut lotten i butik g\xE5r det ocks\xE5 j\xE4ttebra, d\xE5 f\xE5r du en v\xE4rdekod att l\xF6sa in."), React.createElement(Button, {
    block: true,
    className: "margin-bottom-1",
    disabled: !(wonTicketState !== null && wonTicketState !== void 0 && wonTicketState.canRedeem),
    focus: true,
    onClick: redeemWonTicketDigital,
    type: "button"
  }, "Skrapa din Triss digitalt"), React.createElement(Button, {
    block: true,
    disabled: !(wonTicketState !== null && wonTicketState !== void 0 && wonTicketState.canRedeem),
    onClick: redeemWonTicketPhysical,
    transparent: true,
    type: "button"
  }, "H\xE4mta din Triss i butik")), (wonTicketState === null || wonTicketState === void 0 ? void 0 : wonTicketState.redeemType) === 'digital' && React.createElement(Fragment, null, React.createElement("p", null, "Du har redan l\xF6st ut din Trisslott digitalt."), React.createElement("div", {
    className: "margin-top-1-half"
  }, React.createElement(Button, {
    block: true,
    focus: true,
    onClick: () => svs.utils.url.navigate(svs.core.urlMapping.get('triss_BetDetail').replace(':wagerId', wonTicketState.data.wagerId)),
    type: "button"
  }, "Visa min Triss"))), (wonTicketState === null || wonTicketState === void 0 ? void 0 : wonTicketState.redeemType) === 'physical' && React.createElement(Fragment, null, React.createElement("p", null, "Du har redan l\xF6st ut din Triss som en v\xE4rdekod att l\xF6sa in i butik."), React.createElement("div", {
    className: "margin-top-1-half"
  }, React.createElement(Button, {
    block: true,
    focus: true,
    onClick: () => svs.ticketsValidate.utils.navigateToVoucher(wonTicketState.data),
    type: "button"
  }, "Visa min v\xE4rdekod"))), paused && React.createElement("p", null, "30 kr has satts in p\xE5 ditt Spelkonto vilket motsvarar v\xE4rdet p\xE5 lotten.")));
};
const WinActions = _ref4 => {
  let winAmount = _ref4.winAmount,
    winType = _ref4.winType,
    trackType = _ref4.trackType,
    paused = _ref4.paused,
    ticketId = _ref4.ticketId,
    ticketPrice = _ref4.ticketPrice,
    resolvedBranding = _ref4.resolvedBranding;
  const _ReactRouterDOM$useLo = ReactRouterDOM.useLocation(),
    pathname = _ReactRouterDOM$useLo.pathname;
  const isPlural = Math.floor(winAmount / ticketPrice) > 1;
  const envelopeTitle = isPlural ? 'Vill du lösa in din vinst mot nya lotter?' : 'Vill du lösa in din vinst mot en ny lott?';
  const confirmRedeemTicket = () => {
    if (winAmount > 150) {
      const ticketValidateHome = svs.core.urlMapping.get('ticketValidateHome');
      svs.utils.url.navigate("".concat(ticketValidateHome === null || ticketValidateHome === void 0 ? void 0 : ticketValidateHome.replace(':branding', resolvedBranding), "/hogvinst"));
    } else {
      svs.utils.url.navigate("".concat(svs.core.data.baseUrl).concat(pathname, "/los-in"));
    }
  };
  const confirmGamingAccount = () => {
    tracking.trackValidateKeepWinChosen(trackType);
    svs.utils.url.navigate("".concat(svs.core.urlMapping.get('transactionsAccountHistory')));
  };
  if (winType === WIN_ONE_TICKET) {
    return React.createElement(WonTicketWinActions, {
      paused: paused,
      ticketId: ticketId
    });
  } else if (winType) {
    return React.createElement("div", {
      "data-testid": "tickets-validate-high-win"
    });
  }
  return React.createElement("div", {
    className: "u-flex u-flex-column u-flex-justify-content-center padding-bottom-1"
  }, React.createElement("h4", {
    className: "h4 margin-top-1 validate-font-weight"
  }, envelopeTitle), React.createElement("div", {
    className: "u-flex u-flex-column"
  }, !paused && React.createElement(Button, {
    block: true,
    className: "margin-bottom-1",
    focus: true,
    onClick: confirmRedeemTicket,
    type: "button"
  }, "Ja, det l\xE5ter bra!"), React.createElement(Button, {
    block: true,
    className: "confirmGamingAccountButton u-text-decoration-underline",
    onClick: confirmGamingAccount,
    transparent: true,
    type: "button"
  }, "G\xE5 till ditt spelkonto")));
};
setGlobal('svs.ticketsValidate.pages.Validated', _ref5 => {
  let match = _ref5.match;
  const _ReactRouterDOM$useLo2 = ReactRouterDOM.useLocation(),
    pathname = _ReactRouterDOM$useLo2.pathname;
  const _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    bubbleWinOptions = _useState2[0],
    setBubbleWinOptions = _useState2[1];
  const ticketInfo = svs.ticketsValidate.data.retailTicketInfo;
  const productType = ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.type;
  const ticketId = match.params.ticketId;
  const ticketBranding = svs.ticketsValidate.utils.getBrandByTicketId(ticketId) || templateBranding;
  const resolvedBranding = (ticketBranding || '').includes('triss') ? 'triss' : 'skrapspel';
  const shortName = svs.ticketsValidate.utils.getShortNameByTicketId(ticketId);
  const _svs$ticketsValidate$ = svs.ticketsValidate.components.context.useValidateContext(),
    state = _svs$ticketsValidate$.state;
  const _svs$ticketsValidate$2 = svs.ticketsValidate.pages.validated.useDepositLimits(),
    fetchingDepositLimits = _svs$ticketsValidate$2.fetchingDepositLimits,
    _svs$ticketsValidate$3 = _svs$ticketsValidate$2.hasDepositLimits,
    hasDepositLimits = _svs$ticketsValidate$3 === void 0 ? false : _svs$ticketsValidate$3;
  const isPausedOrHasDepositLimits = svs.tur.data.pauseCheck.isPaused || hasDepositLimits;
  const image = ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.image;
  const result = state.result;
  const winAmount = (bubbleWinOptions === null || bubbleWinOptions === void 0 ? void 0 : bubbleWinOptions.amount) || 0;
  const shouldShowGamingAccountInfo = result.winAmount > 0 && (bubbleWinOptions === null || bubbleWinOptions === void 0 ? void 0 : bubbleWinOptions.extraicon) !== WIN_ONE_TICKET;
  const brand = resolvedBranding;
  const trackType = shortName || productType;
  useEffect(() => {
    const normalizedWin = svs.ticketUtility.utils.normalizeWinRetail(result);
    setBubbleWinOptions(_objectSpread({
      demo: false,
      product: ticketInfo.type,
      disableGrassroot: true
    }, normalizedWin));
    if (normalizedWin.winFlag) {
      setTimeout(() => {
        svs.tur.confettiCannon();
      }, 750);
    }
  }, [result, ticketInfo]);
  const onBuyDigitalTickets = () => {
    tracking.trackValidateBuyNewTicketsOnlineChosen(trackType);
    if (winAmount < ticketInfo.price || winAmount > 150) {
      const home = resolvedBranding === 'triss' ? svs.core.urlMapping.get('trissHome') : svs.core.urlMapping.get('skrapspelHome');
      svs.utils.url.navigate("".concat(home, "?rl=").concat(encodeURIComponent(JSON.stringify({
        winAmount
      }))));
    } else {
      const returnUrl = encodeURIComponent("".concat(svs.core.data.baseUrl).concat(pathname));
      svs.utils.url.navigate("/".concat(brand, "/kop-flera/kop/").concat(productType, "?vinst=").concat(winAmount, "&returnUrl=").concat(returnUrl));
    }
  };
  const onValidateNewTicket = e => {
    e === null || e === void 0 || e.preventDefault();
    tracking.trackValidateCorrectNewTicket(shortName);
    const ticketsValidateManualUrl = svs.core.urlMapping.get('ticketsValidateManual');
    svs.utils.url.navigate(ticketsValidateManualUrl);
  };
  if (fetchingDepositLimits) {
    return null;
  }
  return React.createElement(PageWrapper, {
    className: "validated-page padding-top-3"
  }, React.createElement(React.Fragment, null, bubbleWinOptions && React.createElement("div", {
    className: "bubble-win-message-wrapper"
  }, React.createElement(BubbleWinMessage, {
    options: bubbleWinOptions
  })), React.createElement("div", {
    className: "u-flex u-flex-justify-content-center padding-top-1"
  }, React.createElement(Envelope, {
    branding: ticketBranding,
    image: image,
    repeatImage: 1
  }, bubbleWinOptions !== null && bubbleWinOptions !== void 0 && bubbleWinOptions.amount ? React.createElement(WinActions, {
    paused: isPausedOrHasDepositLimits,
    resolvedBranding: resolvedBranding,
    ticketId: ticketId,
    ticketPrice: ticketInfo.price,
    trackType: trackType,
    winAmount: bubbleWinOptions.amount,
    winType: bubbleWinOptions.extraicon
  }) : React.createElement("div", {
    className: "u-flex u-flex-column u-flex-justify-content-center padding-top-2"
  }, !isPausedOrHasDepositLimits && React.createElement(Button, {
    block: true,
    className: "margin-bottom-1",
    focus: true,
    onClick: onBuyDigitalTickets,
    type: "button"
  }, "K\xF6p ny digital lott"), React.createElement(Button, {
    block: true,
    className: isPausedOrHasDepositLimits ? 'margin-top-1' : '',
    focus: true,
    onClick: onValidateNewTicket,
    transparent: true,
    type: "button"
  }, "R\xE4tta ny lott")))), React.createElement("div", {
    className: "u-flex u-flex-justify-content-center margin-top-2"
  }, React.createElement("div", {
    className: "tickets-validate-envelope-width"
  }, shouldShowGamingAccountInfo && React.createElement(GamingAccountInfo, null)))));
});

 })(window);